import script from "./legoRadioWrapperExtend.vue?vue&type=script&lang=js"
export * from "./legoRadioWrapperExtend.vue?vue&type=script&lang=js"

import "./legoRadioWrapperExtend.vue?vue&type=style&index=0&id=9e332cec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e332cec"],['__file',"src/components/lego/extend/legoRadioWrapperExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e332cec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e332cec', __exports__)) {
    api.reload('9e332cec', __exports__)
  }
  
}


export default __exports__